import { TextField } from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 7);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function AtRistkByAgent() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [office, setOffice] = useState("");
  const onOfficeChanged = useCallback((o) => setOffice(o), []);
  const { values: offices } = useDataFormatterHook({
    addEmpty: true,
    value: "officeName",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  const [lineType, setLineType] = useState("");
  const onLineTypeChanged = useCallback((l) => setLineType(l), []);
  const { values: lineTypes } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/LineType/GetLineTypes`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          className="flex-1"
          required
          variant="outlined"
          id="gameDateTime"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Line Type"
          name="name"
          data={lineTypes}
          placeholder="DataFormatter"
          setSelectValue={onLineTypeChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />
      </div>
      <Report
        groupBy="agent"
        title="At Risk By Agent Report"
        getUrl={() => "/Reports/Report_Risk_Amount_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Book: book,
          Group: group,
          Office: office,
          LineType: lineType,
          AgentFrom: agentFrom,
          AgentTo: agentTo,
        })}
        getTotals={(data) => ({
          player: `Total by ${data?.[0]?.agent}`,
          riskAmount: data.reduce((acc, curr) => acc + curr.riskAmount, 0),
        })}
        getGlobalTotals={(data) => ({
          player: `Total`,
          riskAmount: data.reduce((acc, curr) => acc + curr.riskAmount, 0),
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="player">
          Player
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="riskAmount"
          dataFormat={decimalInvertedReportFormatter}
        >
          Risk Amount
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default AtRistkByAgent;
